module.exports = __webpack_public_path__ + "img/avatar5.d3c563e8.png";